import {
  TRIGGER_PAYMENTS_FAILED,
  TRIGGER_PAYMENTS_LOADING,
  TRIGGER_PAYMENTS_REMOVE,
  TRIGGER_PAYMENTS_SUCCESS,
} from "../types";

type TriggerState = {
  loading: boolean;
  error: string | null;
  status: number | null;
  data: any;
};

const initialState: TriggerState = {
  loading: false,
  error: null,
  status: null,
  data: null,
};

export const triggerPaymentsReducer = (
  state = initialState,
  action: any
): TriggerState => {
  switch (action.type) {
    case TRIGGER_PAYMENTS_LOADING:
      return { ...state, loading: action.loading ?? true };
    case TRIGGER_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: action.status,
        error: null,
      };
    case TRIGGER_PAYMENTS_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: action.error,
      };
    case TRIGGER_PAYMENTS_REMOVE:
      return initialState;
    default:
      return state;
  }
};
